import { query } from '@confluence/query-preloader-tools';

import type { ContentStatus } from '../constants/ContentStatus';
import { getQuerySingleContentStatusArrayVariable } from '../utils/getQuerySingleContentStatusArrayVariable';
import { ContentDataClassificationQuery } from '../queries/ContentDataClassificationQuery.graphql';

export function preloadContentDataClassification(contentId: string, contentStatus: ContentStatus) {
	return query({
		query: ContentDataClassificationQuery,
		variables: {
			contentId,
			lowerCaseContentStatusArray: getQuerySingleContentStatusArrayVariable([contentStatus]),
		},
	});
}
